import React from 'react';
import AppRouting from "./AppRouting";
import AppWrappers from "./AppWrappers";


const App = () => (
  <AppWrappers>
    <AppRouting/>
  </AppWrappers>
);

export default App;
